module.exports = __webpack_public_path__ + "media/images/riders/SERGIO_GUTIERREZ_MANTECON-8b9cf4ef676d4484bace2aad6c0c48aa.png";